/* eslint-disable react/no-danger */

import { useParams } from 'react-router';

import { createTranslatedText } from '@dreryk/react-common';
import { NotFoundPanel } from '@dreryk/react-components';

import { StatisticsHeader } from '../../common/StatisticsHeader';

import { DownloadAsCsvLink } from './actionBar/DownloadAsCsvLink';
import { PrintAction } from './actionBar/PrintAction';
import { StatisticsPreviewActionBar } from './actionBar/StatisticsPreviewActionBar';
import { StatisticsPreviewHeaderLoader } from './StatisticsPreviewHeaderLoader';
import { StatisticsPreviewLoader } from './StatisticsPreviewLoader';
import { StatisticsPreviewTable } from './StatisticsPreviewTable';

type StatisticsPreviewPanelParams = {
   statisticsId: string;
};

export const StatisticsPreviewPanel = (): JSX.Element => {
   const params = useParams<StatisticsPreviewPanelParams>();
   const statisticsId = Number(params.statisticsId);

   if (isNaN(statisticsId)) {
      return <NotFoundPanel />;
   }

   return (
      <>
         <StatisticsPreviewHeaderLoader statisticsId={statisticsId}>
            {({ statisticsOrder }) => (
               <>
                  <StatisticsHeader
                     text={createTranslatedText(statisticsOrder.name)}
                     testId={'statisticsPreviewHeader'}
                  />
                  <StatisticsPreviewLoader statisticsId={statisticsId}>
                     {({ statisticsData }) => <StatisticsPreviewTable data={statisticsData} />}
                  </StatisticsPreviewLoader>
               </>
            )}
         </StatisticsPreviewHeaderLoader>
         <StatisticsPreviewActionBar>
            <DownloadAsCsvLink statisticsId={statisticsId} />
            <PrintAction statisticsId={statisticsId} />
         </StatisticsPreviewActionBar>
      </>
   );
};
